export default __webpack_public_path__ + "ac768bcc7f8f776169fa3a8b71b79ecd.svg";